module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step0_Title_card.40a800b3.jpg";